<template>
  <TransitionGroup
    name="action-list"
    tag="ul"
  >
    <slot />
  </TransitionGroup>
</template>

<style>
.action-list-move,
.action-list-enter-active,
.action-list-leave-active {
  transition: all 0.3s ease;
}

.action-list-enter-from,
.action-list-leave-to {
  opacity: 0;
  transform: scaleY(0.01) translate(30px, 0);
}

.action-list-leave-active {
  position: absolute;
}
</style>
